import { cdnEndpoints } from './cdn-endpoints.function';
import { firebaseConfigQa } from './firebase/firebase.qa';

// Archivo usado al hacer deploy a staging (online)
const apiQA = 'https://api-qa.sancristobalonline.com.ar/';
const cdnBaseUrl = 'https://content-qa.gruposancristobal.com/';

const apiBaseUrl = apiQA;

export const environment = {
  version: require('../../package.json').version,
  dependencies: require('../../package.json').dependencies,
  type: {
    id: 'stag',
    name: 'Staging'
  },
  apiBaseUrl: apiBaseUrl,
  production: false,
  legacyPortal: 'https://diw2k3mul01/PortalSCNet/Productores/homeproductores.aspx',
  legacyPortalBase: 'https://row2k16tst01.gruposancristobal.org.ar',
  OORRPortalBase: 'https://staging-siniestrosrsvs.sancristobalonline.com.ar',
  thirdPartyPortalBase: 'https://staging.sancristobalonline.com.ar',
  apiAuthUrl: apiBaseUrl + 'authapi',
  apiClaim: apiBaseUrl + 'siniestros-claim',
  apiAdmin: apiBaseUrl + 'siniestros-claimadmin',
  apiCommercialAutoUrl: apiBaseUrl + 'portalpas-commercialauto',
  apiUtilityUrl: apiBaseUrl + 'utility',
  apiNotifications: apiBaseUrl + 'siniestros-notification',
  ca7claim: apiBaseUrl + 'siniestros-ca7claim/api',
  account: 'claimimages',
  container: 'claimimages',
  appInsightsKey: '7d08c660-8278-4afb-99c3-b28082424b8d',
  hotJarSiteId: 880032,
  apiClaimV2: apiBaseUrl + 'claim/api',
  lender: apiBaseUrl + `lender/api`,
  google: {
    taskManager: {
      token: 'GTM-5GX3GP9'
    }
  },
  server: {
    web: {
      home: 'https://portalpas-qa.sancristobalonline.com.ar'
    }
  },
  cdn: cdnEndpoints(cdnBaseUrl),
  firebase: firebaseConfigQa,
};
